const SelectListItemData = function (key = '', label = '', value = '', isDisabled = false) {
  this.key = key;
  this.label = label;
  this.value = value;
  this.isDisabled = isDisabled;
};

export default SelectListItemData;